import { useCallback, useEffect } from 'react';

/*
 * @param {ref} ref - ref for which we want to detect outside clicks
 * @param {handler} handler - executes callback when outside click happens
 * */
export function useOutsideClick(ref, handler) {
  const handleClick = useCallback(handler, []);

  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handleClick(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handleClick]);
}
